import { createSlice } from "@reduxjs/toolkit";

const belyftedTransferSlice = createSlice({
  name: "belyftedTransfer",
  initialState: {
    recipientData: null,
    amountData: null,
  },
  reducers: {
    setBelyftedRecipientData: (state, action) => {
      state.recipientData = action.payload;
    },
    setBelyftedAmountData: (state, action) => {
      state.amountData = action.payload;
    },
    clearBelyftedTransfer: (state) => {
      state.recipientData = null;
      state.amountData = null;
    },
  },
});

export const { setBelyftedRecipientData, setBelyftedAmountData, clearBelyftedTransfer } = belyftedTransferSlice.actions;
export default belyftedTransferSlice.reducer;
